import Vue from 'vue';
import ActionModal from "../components/ActionModal";
import buildFormParams from '../mixins/formParamBuilder';
import redtail from '../mixins/redtail';
import axios from 'axios';

Vue.component('link-redtail-account', {
  data() {
    return {
      processing: true,
      userKey: null,
      error: null,
      validator: null,
      formParams: {userKey: '', username: ''}
    }
  },
  props: {
    profileLocked: {
      type: Boolean,
      required: true,
      default: false,
    },
    profileApproved: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  computed: {
    userKeyMasked() {
      return "XXXXXXXX-XXXX-XXXX-XXXX-XXXXX" + this.userKey.substr(this.userKey.length - 6);
    }
  },
  mixins: [buildFormParams, redtail],
  mounted() {
    setTimeout( () => {
      axios.get('/api/?entity=vessel&action=getRedtailIntegration&refreshSession=1').then( (response) => {
        let redtail = response.data;

        if (response !== false) {
          this.userKey = redtail.user_key;
        }
        this.processing = false;
      });
    }, 2000);
  },
  components: {ActionModal}
});
